import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditGuardian from '../../components/guardians/FormAddEditGuardian';
import { useParams } from 'react-router-dom';
import { useGetGuardian } from '../../hooks/guardians/useGetGuardian';
import LoadingPage from '../../components/global/LoadingPage';
const EditGuardian = () => {
    const { id } = useParams();
    const { guardian, isLoading } = useGetGuardian(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditGuardian isEdit currentData={guardian?.data} /></WrapperSection>);
};
export default EditGuardian;
